import React, { useEffect, useMemo, useState } from "react";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as MapPad } from "../../../../assets/images/signUp/man-with-pad.svg";
import Logo from "../../Logo";
import { SideSVG } from "../../../common";
import { useSelector, useDispatch } from "react-redux";
import {
  useCreateCompanyMutation,
  useIndividualCompanyMutation,
} from "../../../../store/Company/companyApiSlice";
import { setCompanyData } from "../../../../store/Company/companySlice";
import { Countries } from "../../Home/CountryFlag";
import ReactGA from "react-ga4";
import { setClearClaimDetails, setFilledCompany } from "../../../../store/claim/claimSlice";

const FilledCompany = ({ company, onNext, onPrev }) => {
  const dispatch = useDispatch();
  const { filledCompany } = useSelector((state) => state.claims);

  const [isAcknowledged, setIsAcknowledged] = useState(false)

  let [currentCountry] = Countries.filter(
    (country) => country.code === (company?.country_code || company?.data?.country_code)
  );

  const { token, userInfo } = useSelector((state) => state.auth);

  const [createCompany, { isLoading: companyCreating }] = useCreateCompanyMutation();

  const isTrevexCompany = company?.isTrevex;

  const handleCompanySave = async () => {
    ReactGA.event({
      category: 'Started Claim',
      action: 'Claim Process:Started Claim with Claim',
      label: `Started Claim Process step 1; "${userInfo?.email?.replace(/@/g, '=')}"`
    });
    if (isTrevexCompany) {
      dispatch(setCompanyData(company));
      onNext();
    }
    else {
      const jsonData = {
        registered_company_name: company?.data?.registered_company_name || company?.registered_company_name,
        wb_win: company?.data?.wb_win || company?.wb_win,
        country_code: currentCountry?.code,
        new_company: 0,
        companyID: company?.data?.companyID || company?.companyID,
      };
      dispatch(setFilledCompany(jsonData));
      onNext();
    }
  };

  useMemo(() => {
    const companyName = (company?.data?.registered_company_name || company?.registered_company_name);
    const filledCompanyName = filledCompany?.registered_company_name;
    if (filledCompanyName && companyName && (filledCompanyName !== companyName)) {
      dispatch(setClearClaimDetails());
    }
  }, [company])

  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex -mx-4 xl:items-center items-center max-h-screen">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md lg:py-20 mx-auto ">
                <h3 className="font-heading text-f24 sm:text-f30 text-primary font-bold mb-4 text-center punitpunit">
                  Name of Registered Company
                </h3>
                <p className="text-f16 sm:text-f18 text-secondarytwo mb-4">
                  Please ensure you've selected the correct company, as this information cannot be edited later.
                </p>
                <form>
                  <label
                    for="search-dropdown"
                    className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
                  >
                    Country
                  </label>
                  <div className="flex mt-2 mb-4">
                    <div className="relative w-full">
                      <div
                        className="flex text-left text-xs overflow-hidden p-2.5 w-full z-20 text-sm text-secondary bg-inputDisable rounded-md border border-gray-300"
                        role="presentation"
                      >
                        {currentCountry?.file_url && (
                          <img
                            src={currentCountry.file_url}
                            width="20px"
                            height="20px"
                            className="mr-2 h-5"
                            alt="hello"
                          />
                        )}
                        {currentCountry?.name} ({currentCountry?.code})
                      </div>
                    </div>
                  </div>
                  <label
                    for="search-dropdown"
                    className="block mb-1 text-sm text-secondarytwo font-semibold text-left"
                  >
                    Company Name<br />
                  </label>
                  <div className="flex mt-2 mb-2">
                    <div className="relative w-full">
                      <input
                        disabled
                        type="text"
                        id="search-dropdown"
                        className="block p-2.5 w-full z-20 text-sm text-secondary bg-inputDisable rounded-md border border-gray-300 "
                        placeholder="Company name"
                        required
                        value={company?.registered_company_name || company?.data?.registered_company_name}
                      />
                    </div>
                  </div>
                  <div className="flex">
                    <input
                      type="checkbox"
                      checked={isAcknowledged}
                      onChange={() => { setIsAcknowledged(!isAcknowledged) }}
                      id="acknowledgementCheckbox"
                      className="m-3"
                    />
                    <label className="text-secondary pt-2 pb-4 text-f12 text-left" htmlFor="acknowledgementCheckbox">I confirm that I am the authorized representative to manage our company's profile on TREVEX, allowing me to update and maintain our information as needed.</label>
                  </div>
                </form>
                <div className="flex justify-between gap-2 mt-4">
                  <button
                    className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"

                  >
                    <ArrowLeft onClick={onPrev} />
                    <span className="relative" onClick={onPrev}>Go Back</span>
                  </button>
                  <button
                    className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${!isAcknowledged ? "cursor-not-allowed bg-disable" : "cursor-pointer bg-primary"} `}
                    onClick={handleCompanySave}
                    disabled={!isAcknowledged}
                  >
                    <span className="relative">
                      {companyCreating ? <Spinner /> : "Save & Continue"}
                    </span>
                    <ArrowRight />
                  </button>
                </div>
              </div>
            </div>

            <SideSVG SVG={MapPad} positions="bottom-0  left-[-25%]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilledCompany;
